import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  @Input()
  logOut:boolean = false;

  @Input()
  showMenu: boolean = false; 

  @Input()
  showBackButton: boolean = true;

  @Input()
  showLogOutButton: boolean = true;

  @Output()
  buttonBack= new EventEmitter<void>();

  @Output()
  cancelLogOut= new EventEmitter<void>();

  ngOnInit(): void {
    this.logOut = false;
  }

  logOutModal(){
    this.logOut = true
  }

  returnSign(){
    this.logOut = false
    this.cancelLogOut.emit()
  }

  backMenu(){
    this.buttonBack.emit()
  }

}
